import React from 'react'
import Carousel from 'react-bootstrap/Carousel'
import Slide1 from '../../assets/img/carousal/slide1.webp'
import ScrollDown from '../scroll-down/scroll-down.component'


import './my-carousal.style.css'

const MyCarousal = () => {
    return (
        <div id="home">
<Carousel controls={false} indicators interval={2500} pauseOnHover={false}>
  <Carousel.Item>
    <img
      className="d-block w-100 custom-img"
      src={Slide1}
      alt="First slide"
    />
  </Carousel.Item>
</Carousel>
<ScrollDown/>
</div>
    )
}

export default MyCarousal